import { BPButton } from "@/components/bp/bpbutton";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Header, Input, Menu, Segment } from "@/components/bp/bp-ui";

interface BPBoxWithHeaderProps {
    header?: string | React.ReactNode;
    children?: React.ReactNode;
    scrolling?: boolean;
    compact?: boolean;
    forPrint?: boolean;
    buttons?: Array<{ label: string, to?: string, action?: () => Promise<any> | void, negative?: boolean, showIf?: boolean, positive?: boolean }>;
    onFilter?: (filterText: string) => void;
}

export function BPBoxWithHeader(props: BPBoxWithHeaderProps) {
    const scrollingStyle = props.scrolling && !props.forPrint ? { style: { 'maxHeight': '50vh', 'overflowY': 'auto' } } : {}
    const compact = (props.compact ?? props.forPrint) ?? false;
    const noBorder = props.forPrint;
    const [filterValue, setFilterValue] = useState<string>("")

    return (
        <>
            {props.header &&
                <Header attached={'top'} style={{ clear: 'both' }}
                    as={compact == false ? 'h3' : 'h4'}
                    className={`${noBorder ? 'no-border' : ''}`}>
                    {props.header}
                    {
                        (props.buttons ?? []).filter(m => m.showIf == null || m.showIf).map(m => (
                            <BPButton compact floated={'right'} positive={m.positive} negative={m.negative} key={m.label} as={m.to != null ? Link : Button} to={m.to} onClick={(e) => {
                                if (m.action != null) {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    m.action()
                                }
                            }}>{m.label}</BPButton>
                        ))
                    }
                    {props.onFilter && (
                        <div style={{ float: "right" }}>
                            <Input transparent size={'mini'} placeholder={window.translation.dataTable.search} icon={'search'} value={filterValue} onChange={(ev, data) => {
                                setFilterValue(data.value)
                                props.onFilter(data.value)
                            }} ></Input>

                        </div>
                    )}
                </Header>
            }
            <Segment attached {...scrollingStyle} compact={compact} className={(compact) ? 'no-padding no-border' : ''}>
                {props.children}
            </Segment>
        </>
    )
}